import { enviarFormulario, obterHtml, obterJson } from './api';
import { comBotao, ocupado, ocupar } from './botao';
import { abrirAlertaDaBusca, obterAlertaDaBusca } from './alertaJanela';
import { aoExibirPagina, formatar, url } from './config';
import { avisar, avisarErro, avisarSucesso } from './aviso';
import { desempilhar, empilhar, travarFundo } from './sobreposicao';
import { alternarSalva, estaSalva, salvasNaConta } from './salvas';
import { registrarConversaoCandidatura, registrarEvento } from './medicao';
import { obterGeo, obterUsuario } from './usuario';

// A vaga aberta na busca (v36): painel ao lado no computador, sheet de baixo no celular. O corpo vem do servidor
// (?parcial=corpo, público e cacheado) e o botão de candidatura do BotaoCandidatar, sem cache, a cada vez que a vaga abre.
const $ = id => document.getElementById(id);
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const ico = (n, cls = '') => `<svg class="ico ${cls}" aria-hidden="true"><use href="#i-${n}"></use></svg>`;
const ehCelular = () => !window.matchMedia('(min-width: 960px)').matches;
const fmt = n => Number(n).toLocaleString(document.documentElement.lang || 'pt-BR');
const skLinha = (w, h = 12) => `<span class="sk" style="width:${w};height:${h}px"></span>`;

let T = {};
// itens: onde estão os cards da lista (a busca; a página da empresa usa as linhas dela). padrao: empresa e logo de
// quando a linha não traz (na página da empresa eles não se repetem em cada vaga).
// pagina: o id da vaga quando o detalhe é a própria página da vaga (o mesmo corpo do painel, já no HTML do servidor).
let _opcoes = { lista: () => [], total: () => 0, carregarMais: async () => false, aoFecharSheet: () => {}, itens: '#resList .card', padrao: {}, pagina: 0 };
let _sel = null;
let _sheet = null;
let _ultimaDoSheet = null;
let _confirmando = null;
let _confirmouEm = 0;
let _trilha = [];
let _pendente = null;
let _confirmarAoAbrir = null;
let _enviando = false;
let _saindo = false;

// Mesmo contrato do v1 (utilidades/candidaturaPendente.js): a vaga que a pessoa começou e não terminou. O login volta
// para ela (?confirmar=1), o cadastro e o currículo a mostram; logado, o servidor também guarda (o lembrete).
// O "t" é da v2: o login v2 ignora a pendência com mais de 24 horas (o v1 lê o resto e não usa o "t"). Também da v2, o que o
// login mostra da vaga no alto: empresa, logo, local, confidencial e se ela pede currículo completo (cv).
async function salvarPendencia(id, titulo, endereco, possivelmenteLogado) {
    const artigo = _artigo();
    const daVaga = artigo && +artigo.dataset.id === +id ? artigo.dataset : {};
    try {
        localStorage.setItem('candidaturaPendente', JSON.stringify({
            vagaID: String(id),
            titulo: titulo || '',
            url: String(endereco || '').replace(/https?:\/\/[^/]+/, ''),
            t: Date.now(),
            empresa: daVaga.empresa || '',
            logo: daVaga.logo || '',
            local: daVaga.local || '',
            conf: !!daVaga.confidencial,
            cv: !!_estadoCta.get(+id)?.curriculoCompleto
        }));
    } catch {
        // Sem armazenamento: a pessoa volta à vaga pelo ReturnUrl do login.
    }
    if (possivelmenteLogado) {
        const dados = new FormData();
        dados.append('vagaID', id);
        try {
            await enviarFormulario(url('/Vagas/SalvarCandidaturaPendente'), dados);
        } catch {
            // O lembrete do servidor é ajuda: a candidatura segue sem ele.
        }
    }
}

// Enviada a candidatura (ou sem como enviar: vaga encerrada, bloqueio), a pendência desta vaga sai. A de outra vaga fica
// (outra aba): o login só a usa quando volta para ela.
function removerPendencia(id) {
    try {
        const p = JSON.parse(localStorage.getItem('candidaturaPendente'));
        if (p && +p.vagaID === +id) {
            localStorage.removeItem('candidaturaPendente');
        }
    } catch {
        // Sem armazenamento: não há pendência guardada.
    }
}
// A pendência deste aparelho é desta vaga e ainda vale (as 24 horas do login v2).
function _pendenciaDaVaga(id) {
    try {
        const p = JSON.parse(localStorage.getItem('candidaturaPendente'));
        return !!p && +p.vagaID === +id && !!p.t && Date.now() - p.t <= 24 * 60 * 60 * 1000;
    } catch {
        return false;
    }
}
// Os estados em que o v1 (vagas-detalhes.js) tira a pendência: já inscrito, vaga encerrada e os bloqueios.
const _semPendencia = new Set(['Inscrito', 'VagaEncerrada', 'CurriculoNaoPermitido', 'CurriculoNaoExiste', 'LimiteUltrapassado', 'SomenteColaboradores', 'SomenteColaboradoresDaEmpresa', 'SomenteCandidatos', 'DeficienciaObrigatoria', 'AlunoNaoEncontrado', 'AlunoExAluno']);
const tiraPendencia = r => _semPendencia.has(r?.retorno);

// Visualização da vaga (SalvarVisualizacao do v1, o número que a empresa vê): uma por vaga aberta nesta página. Não
// conta quem já se candidatou, vaga encerrada, resposta de erro nem a volta do login (?confirmar=1, lido ao carregar:
// o painel tira o parâmetro do endereço). origem: de onde a pessoa chegou à vaga (na página, o referrer, como no v1).
const _visualizadas = new Set();
const _voltaDoLogin = new URLSearchParams(window.location.search).get('confirmar') === '1';
function registrarVisualizacao(id, r, { origem = _origem() } = {}) {
    if (!id || _visualizadas.has(id) || !r || r.sucesso === false || r.retorno === 'VagaEncerrada' || r.retorno === 'Inscrito' || _voltaDoLogin) {
        return;
    }
    _visualizadas.add(id);
    const dados = new FormData();
    dados.append('vagaID', id);
    dados.append('origem', origem);
    dados.append('pessoaID', r.pessoaID ?? '');
    dados.append('url', window.location.hostname);
    dados.append('dispositivo', _dispositivo());
    // A resposta é texto ("true"), não JSON. Vaga pré-renderizada pelo app só conta quando a pessoa a abre.
    aoExibirPagina(() => fetch(url('/Vagas/SalvarVisualizacao'), { method: 'POST', body: dados, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } }).catch(() => {}));
}

// Candidatura pelo WhatsApp (modal-candidatura-whatsapp do v1): no computador, o QR code para continuar no celular ou o
// WhatsApp Web; no celular e no tablet, a conversa direto. O aparelho é o do userAgent, como no v1.
async function candidatarPeloWhatsApp(id, { titulo = '', endereco = '' } = {}) {
    salvarPendencia(id, titulo, endereco, false);
    const caminho = `/whatsapp/${id}`;
    const janela = $('dlgWhatsApp');
    if (_dispositivo() !== 'Desktop' || !janela) {
        window.location.href = caminho;
        return;
    }
    $('qrWhatsAppWeb').href = caminho;
    try {
        const { default: qrcode } = await import('qrcode-generator');
        const qr = qrcode(4, 'L');
        qr.addData(`${window.location.origin}${caminho}`);
        qr.make();
        $('qrWhatsApp').innerHTML = qr.createImgTag(4, 8, T.candidateseWa || '');
    } catch {
        // Sem o QR (chunk que não baixou), o WhatsApp Web continua na janela.
        $('qrWhatsApp').innerHTML = '';
    }
    janela.showModal();
}

const _estadoCta = new Map();
// Candidaturas enviadas nesta página: o quadro "Candidatura enviada" (questionário, conta criada, contato, alerta).
const _enviadas = new Map();
// Voltou do login com a vaga em várias cidades: a confirmação abre só para escolher a cidade.
let _faltaCidade = null;
const _corpos = new Map();
const _hrefs = new Map();
// Vagas abertas pela pessoa (clique, toque ou o link ?vaga=): só elas contam visualização; a 1ª que o computador abre sozinho, não.
const _paraVisualizar = new Set();
const _vistas = new Set((() => { try { return JSON.parse(sessionStorage.getItem('v2Vistas') || '[]'); } catch { return []; } })());

// ---------- pedaço do corpo (cache em memória com limite) ----------
function _corpo(id, href) {
    if (_corpos.has(id)) {
        return _corpos.get(id);
    }
    const promessa = obterHtml(`${href}?parcial=corpo`).then(html => {
        // 200 sem a vaga (a página de login ou a de um proxy no lugar do pedaço) é falha: sem isto o esqueleto ficava para sempre.
        if (!_modelo(html)) {
            throw new Error('corpo');
        }
        return html;
    }).catch(e => {
        _corpos.delete(id);
        throw e;
    });
    _corpos.set(id, promessa);
    if (_corpos.size > 40) {
        _corpos.delete(_corpos.keys().next().value);
    }
    return promessa;
}

// Prefetch (mouse parado no card, card parado na tela): no máximo 2 pedidos de uma vez. Abrir a vaga não passa por este limite.
let _prefetchs = 0;
// Economia de dados ou rede de 3G para baixo (navigator.connection, só no Chrome/Android): o corpo vem só ao abrir a vaga.
const _redeCara = () => !!navigator.connection?.saveData || /2g|3g/.test(navigator.connection?.effectiveType || '');
export function prefetch(id) {
    const href = _hrefs.get(id) || _cartao(id)?.querySelector('a[data-vaga]')?.getAttribute('href');
    if (!href || _redeCara()) {
        return;
    }
    _hrefs.set(id, href);
    if (_corpos.has(id) || _prefetchs >= 2) {
        return;
    }
    _prefetchs++;
    _corpo(id, href).catch(() => {}).finally(() => { _prefetchs--; });
}

const _cartao = id => document.querySelector(`${_opcoes.itens}[data-id="${id}"]`);

// A cidade que o card mostrou (a busca pôs primeiro a que tem a ver com ela) vem primeiro também no corpo. Aqui, e não no
// servidor: o corpo é um só por vaga no cache da borda, e o card de agora vale mesmo com o corpo guardado de outra busca.
function _cidadeDoCard(artigo, id) {
    const cidade = _cartao(id)?.dataset.cidade;
    const lista = artigo.querySelector('.vd__cities');
    const item = cidade ? lista?.querySelector(`li[data-cidade="${CSS.escape(cidade)}"]`) : null;
    if (!item || item === lista.firstElementChild) {
        return;
    }
    lista.prepend(item);
    const primeira = artigo.querySelector('[data-cidade1]');
    if (primeira) {
        primeira.textContent = item.textContent;
    }
    artigo.dataset.local = item.dataset.local || artigo.dataset.local;
    artigo.dataset.alertaLocal = item.dataset.alerta || '';
    // A escolha de cidades da confirmação também começa por ela.
    try {
        const escolha = JSON.parse(artigo.dataset.cidades || '[]');
        const i = escolha.findIndex(c => String(c.id) === cidade);
        if (i > 0) {
            escolha.unshift(...escolha.splice(i, 1));
            artigo.dataset.cidades = JSON.stringify(escolha);
        }
    } catch {
        // Sem a lista, a confirmação fica na ordem da vaga.
    }
}

function _infoDoCartao(id) {
    const c = _cartao(id);
    const a = c?.querySelector('a[data-vaga]');
    if (!a) {
        return null;
    }
    _hrefs.set(id, a.getAttribute('href'));
    return {
        id,
        titulo: (a.querySelector('.ev-t') || a).textContent.trim(),
        href: a.getAttribute('href'),
        empresa: c.querySelector('.card__e')?.textContent.trim() || _opcoes.padrao.empresa || '',
        logo: c.querySelector('.card__logo')?.innerHTML || _opcoes.padrao.logo || '',
        pills: c.querySelector('.card__meta')?.innerHTML || ''
    };
}

// ---------- marcas no card ----------
// A linha da página da empresa não tem onde pôr as marcas: aí não há marca.
function _acoesDoCartao(c) {
    let s = c.querySelector('.card__actions');
    if (!s) {
        c.querySelector('.card__meta')?.insertAdjacentHTML('afterend', '<div class="card__actions"></div>');
        s = c.querySelector('.card__actions');
    }
    return s;
}

export function marcarVista(id) {
    _vistas.add(id);
    try {
        sessionStorage.setItem('v2Vistas', JSON.stringify([..._vistas].slice(-200)));
    } catch {
        // Sem sessionStorage: a marca vale só nesta página.
    }
    const c = _cartao(id);
    if (c && !c.querySelector('.card__seen')) {
        _acoesDoCartao(c)?.insertAdjacentHTML('afterbegin', `<span class="card__seen">${ico('eye')}${esc(T.jaViu)}</span>`);
    }
}

function _marcarEnviada(id) {
    const c = _cartao(id);
    if (!c) {
        return;
    }
    c.querySelector('.card__seen')?.remove();
    _acoesDoCartao(c)?.insertAdjacentHTML('afterbegin', `<span class="card__seen card__seen--ok">${ico('check-circle-fill')}${esc(T.candidaturaEnviada)}</span>`);
}

// Depois de trocar a lista (filtro, próxima página), as vagas já vistas e as candidaturas enviadas voltam a aparecer.
export function remarcarCartoes(enviadas = []) {
    enviadas.forEach(_marcarEnviada);
    document.querySelectorAll('#resList .card[data-id]').forEach(c => {
        const id = +c.dataset.id;
        if (_vistas.has(id) && !c.querySelector('.card__seen')) {
            marcarVista(id);
        }
    });
}

// ---------- skeleton ----------
const _skelCorpo = (comCabecalho) => `<div class="vd vd--sk" aria-busy="true" aria-label="${esc(T.carregandoVaga)}">${comCabecalho ? `<div class="vd__hd"><span class="card__logo sk"></span>${skLinha('180px', 14)}</div>` : ''}${skLinha('60%', 26)}${skLinha('45%', 14)}${skLinha('35%', 14)}${skLinha('50%', 12)}<span class="sk" style="width:150px;height:40px;border-radius:var(--r-card)"></span><span class="sk" style="width:100%;height:110px;border-radius:var(--r-card)"></span>${skLinha('40%', 16)}${skLinha('95%')}${skLinha('90%')}${skLinha('75%')}</div>`;

export const esqueletoVaga = () => _skelCorpo(true);

// O corpo que não veio: só o 404 é a vaga que saiu; servidor fora, tempo esgotado ou rede instável ganham o "Tentar de novo".
const _falhaDoCorpo = e => (navigator.onLine === false ? `<span>${esc(T.semInternetVaga)}</span>` : e?.status === 404 ? `<span>${esc(T.vagaIndisponivel)}</span>`
    : `<span>${esc(T.erroTitulo)}</span><button class="btn btn--sm btn--out" type="button" data-corpo-retry>${esc(T.tentarDeNovo)}</button>`);

// ---------- painel do computador ----------
function _barra(info, artigo) {
    const hd = artigo?.querySelector('.vd__hd');
    const id = hd ? hd.innerHTML : `<span class="card__logo" aria-hidden="true">${info.logo}</span><span class="vd__emp">${esc(info.empresa)}</span>`;
    const fan = artigo?.dataset.fan;
    const mini = fan ? `<a href="${esc(fan)}">${esc(info.empresa)}</a>` : `<span>${esc(info.empresa)}</span>`;
    const salva = estaSalva(info.id);
    const salvar = `<button class="icon-btn icon-btn--flat js-save" type="button" data-id="${info.id}" aria-pressed="${salva}">${ico(salva ? 'bookmark-fill' : 'bookmark')}<span class="icon-btn__l">${esc(salva ? T.salva : T.salvar)}</span></button>`;
    return `<div class="pane__bar"><div class="grow"><div class="pane__id">${id}</div><div class="pane__mini"><b>${esc(info.titulo)}</b>${mini}</div></div>
    ${_confirmando === info.id ? '' : `<button class="btn btn--sm btn--pri pane__ctab js-apply cta-wait" data-cta aria-busy="true" type="button">${ico('clipboard-check')}${esc(T.candidatese)}</button>`}
    ${salvar}
    <button class="icon-btn icon-btn--flat js-share" type="button" aria-haspopup="dialog" aria-expanded="false">${ico('share')}<span class="icon-btn__l">${esc(T.compartilhar)}</span></button>
    <a class="newtab" href="${esc(info.href)}" target="_blank" rel="noopener" title="${esc(T.novaAba)}">${ico('box-arrow-up-right')}${esc(T.novaAba)}</a></div>`;
}

function _infoDoArtigo(artigo, base) {
    return {
        ...base,
        id: +artigo.dataset.id,
        titulo: artigo.dataset.titulo || base?.titulo || '',
        empresa: artigo.dataset.empresa || base?.empresa || '',
        href: artigo.dataset.url || base?.href || '',
        logo: artigo.querySelector('.vd__hd .card__logo')?.innerHTML || base?.logo || ''
    };
}

function _modelo(html) {
    const t = document.createElement('template');
    t.innerHTML = html;
    return t.content.querySelector('article.vd');
}

function _urlComVaga(id) {
    const u = new URL(window.location.href);
    if (id) {
        u.searchParams.set('vaga', id);
    } else {
        u.searchParams.delete('vaga');
    }
    // Sem a página (como no v1): o link abre a busca do início com a vaga aberta, esteja ela em que página estiver.
    u.searchParams.delete('pagina');
    u.searchParams.delete('confirmar');
    return u.pathname + u.search;
}

function _voltarTrilha(artigo) {
    if (!_trilha.length) {
        return;
    }
    const anterior = _trilha[_trilha.length - 1];
    artigo.insertAdjacentHTML('afterbegin', `<button class="vd__back" type="button" data-trail-back>${ico('arrow-left')}${esc(formatar(T.voltarPara, anterior.titulo))}</button>`);
}

export async function selecionarNoPainel(id, { doUsuario = true, visualizar = doUsuario, focar = false, info = null } = {}) {
    const pane = $('pane');
    if (!pane) {
        return;
    }
    if (visualizar) {
        _paraVisualizar.add(id);
    }
    if (_sel && _sel !== id) {
        marcarVista(_sel);
    }
    if (_confirmando !== id) {
        _confirmando = null;
    }
    _sel = id;
    document.querySelectorAll('#resList .card').forEach(c => {
        const on = +c.dataset.id === id;
        c.classList.toggle('is-sel', on);
        const a = c.querySelector('.card__t a');
        if (a) {
            on ? a.setAttribute('aria-current', 'true') : a.removeAttribute('aria-current');
        }
    });
    const base = info || _infoDoCartao(id) || { id, titulo: '', empresa: '', logo: '', href: _hrefs.get(id) };
    pane.classList.remove('is-scrolled');
    const pronto = _corpos.has(id);
    pane.innerHTML = _barra(base, null) + _skelCorpo(false);
    $('paneWrap').scrollTop = 0;
    if (doUsuario) {
        // Cada vaga escolhida é uma entrada no histórico: o Voltar do navegador reabre a anterior (mostrarVagaDoHistorico).
        const endereco = _urlComVaga(id);
        if (endereco !== window.location.pathname + window.location.search) {
            history.pushState(history.state, '', endereco);
        }
        registrarEvento('vaga_aberta', { origem: 'painel', vaga_id: id });
        _opcoes.aoAbrir?.(id);
    }
    let html;
    try {
        html = await _corpo(id, base.href);
    } catch (e) {
        if (_sel === id) {
            _hrefs.set(id, base.href);
            pane.innerHTML = _barra(base, null) + `<div class="vd"><div class="offline" role="status">${_falhaDoCorpo(e)}</div></div>`;
        }
        return;
    }
    if (_sel !== id) {
        return;
    }
    const artigo = _modelo(html);
    if (!artigo) {
        return;
    }
    _cidadeDoCard(artigo, id);
    const infoFinal = _infoDoArtigo(artigo, base);
    artigo.querySelector('.vd__hd')?.remove();
    _voltarTrilha(artigo);
    // Sem o corpo no cache, o skeleton fica um instante (como na v36): a troca não pisca.
    const desenhar = () => {
        if (_sel !== id) {
            return;
        }
        pane.innerHTML = _barra(infoFinal, _modelo(html));
        pane.append(artigo);
        _carregarCta(id);
        if (focar) {
            setTimeout(() => $('vt-pane')?.focus(), 60);
        }
    };
    pronto ? desenhar() : setTimeout(desenhar, 0);
}

// O Voltar (ou o Avançar) do navegador entre as vagas do painel do computador: mostra a do endereço, sem nova entrada.
export function mostrarVagaDoHistorico(id) {
    if (!id || id === _sel) {
        return;
    }
    if (_trilha.length && _trilha[_trilha.length - 1].id === id) {
        _trilha.pop();
    }
    selecionarNoPainel(id, { doUsuario: false, visualizar: false });
    _cartao(id)?.scrollIntoView({ block: 'nearest' });
}

// ---------- sheet (painel que sobe de baixo) ----------
export function abrirSheet(el, { marca, endereco } = {}) {
    const fundo = $('scrim');
    fundo.hidden = false;
    requestAnimationFrame(() => fundo.classList.add('is-on'));
    el.hidden = false;
    el.style.transform = '';
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-open')));
    travarFundo(true);
    if (marca) {
        el.dataset.marca = marca;
        empilhar(marca, () => fecharSheet(el, { peloHistorico: true }), endereco);
    }
}

export function fecharSheet(el, { peloHistorico = false, manterFoco = false } = {}) {
    if (!el || el.hidden) {
        return;
    }
    el.classList.remove('is-open');
    const fundo = $('scrim');
    fundo.classList.remove('is-on');
    setTimeout(() => { if (!document.querySelector('.sheet.is-open')) fundo.hidden = true; }, 220);
    setTimeout(() => { if (!el.classList.contains('is-open')) el.hidden = true; }, 320);
    if (!peloHistorico && el.dataset.marca) {
        desempilhar(el.dataset.marca);
    }
    delete el.dataset.marca;
    travarFundo(false);
    if (el.id === 'sheetVaga') {
        const id = _sheet;
        _sheet = null;
        _confirmando = null;
        _trilha = [];
        if (id) {
            marcarVista(id);
            const c = _cartao(id);
            if (c && !manterFoco) {
                c.scrollIntoView({ block: 'nearest' });
                c.querySelector('a[data-vaga]')?.focus({ preventScroll: true });
            }
        }
        _opcoes.aoFecharSheet(id);
    }
}

export function arrastavel(sheet) {
    let y0 = null;
    let dy = 0;
    let t0 = 0;
    const baixo = e => {
        if (e.target.closest('button:not(.sheet__grab),a,input')) {
            return;
        }
        y0 = e.clientY;
        dy = 0;
        t0 = performance.now();
        sheet.classList.add('is-drag');
        e.currentTarget.setPointerCapture?.(e.pointerId);
    };
    const mover = e => {
        if (y0 === null) {
            return;
        }
        dy = Math.max(0, e.clientY - y0);
        sheet.style.transform = `translateY(${dy}px)`;
    };
    const cima = () => {
        if (y0 === null) {
            return;
        }
        sheet.classList.remove('is-drag');
        const rapido = dy / (performance.now() - t0) > 0.6;
        sheet.style.transform = '';
        if (dy > 120 || (rapido && dy > 40)) {
            fecharSheet(sheet);
        }
        y0 = null;
    };
    sheet.querySelectorAll('[data-drag]').forEach(h => {
        h.addEventListener('pointerdown', baixo);
        h.addEventListener('pointermove', mover);
        h.addEventListener('pointerup', cima);
        h.addEventListener('pointercancel', cima);
    });
}

function _preencherSheet(info) {
    const ids = _opcoes.lista();
    const i = ids.indexOf(info.id);
    $('sheetPos').textContent = i >= 0 ? formatar(T.posicao, i + 1, fmt(_opcoes.total())) : '';
    $('sheetPrev').disabled = i <= 0;
    $('sheetNext').disabled = i < 0 || (i >= ids.length - 1 && !_opcoes.temMais?.());
    const salvar = document.querySelector('#sheetVaga .sheet__hd .js-save');
    const salva = estaSalva(info.id);
    salvar.dataset.id = info.id;
    salvar.setAttribute('aria-pressed', String(salva));
    salvar.innerHTML = `${ico(salva ? 'bookmark-fill' : 'bookmark')}<span class="icon-btn__l">${esc(salva ? T.salva : T.salvar)}</span>`;
    $('shareTg').setAttribute('aria-expanded', 'false');
    const pe = $('sheetFoot');
    pe.classList.add('cta-wait');
    pe.setAttribute('aria-busy', 'true');
    pe.classList.remove('is-confirm', 'has-wa');
    $('sheetWa').hidden = true;
    $('sheetOk').hidden = true;
    const apply = pe.querySelector('.js-apply');
    apply.hidden = false;
    apply.innerHTML = ico('clipboard-check') + esc(T.candidatese);
}

function _extrasDoSheet(artigo, info) {
    const ids = _opcoes.lista();
    const i = ids.indexOf(info.id);
    const proximo = ids[i + 1] ? _infoDoCartao(ids[i + 1]) : null;
    const relatar = artigo.querySelector('.report');
    const extras = `<a class="btn btn--ghost" href="${esc(info.href)}" data-open-page="${info.id}">${ico('box-arrow-up-right')}${esc(T.abrirPagina)}</a>`
        + (proximo ? `<button class="nextjob" type="button" data-next><span><small>${esc(T.proximaVaga)}</small>${esc(proximo.titulo)} · ${esc(proximo.empresa)}</span>${ico('chevron-right')}</button><p class="swipehint">${esc(T.deslize)}</p>` : '');
    relatar ? relatar.insertAdjacentHTML('beforebegin', extras) : artigo.insertAdjacentHTML('beforeend', extras);
}

export async function abrirNoSheet(id, { dir = 0, info = null } = {}) {
    const el = $('sheetVaga');
    if (!el) {
        return;
    }
    const ja = !el.hidden;
    if (_confirmando !== id) {
        _confirmando = null;
    }
    _sheet = _ultimaDoSheet = id;
    _paraVisualizar.add(id);
    const base = info || _infoDoCartao(id) || { id, titulo: '', empresa: '', logo: '', href: _hrefs.get(id), pills: '' };
    _preencherSheet(base);
    const corpo = $('sheetBody');
    // Pinta já o cabeçalho com o que o card tem (resposta imediata ao toque); o corpo vem no quadro seguinte.
    // Nos mesmos blocos (cartões) do corpo que chega depois.
    corpo.innerHTML = `<article class="vd"><div class="vd__bloco"><div class="vd__hd"><span class="card__logo" aria-hidden="true">${base.logo}</span><span class="vd__emp">${esc(base.empresa)}</span></div><h2 class="vd__t" id="vt-sheet" tabindex="-1">${esc(base.titulo)}</h2>${base.pills ? `<div class="vd__pills">${base.pills}</div>` : ''}</div><div class="vd__bloco">${navigator.onLine === false && !_corpos.has(id) ? `<div class="offline"><span>${esc(T.semInternetVaga)}</span></div>` : _skelCorpo(false)}</div></article>`;
    corpo.scrollTop = 0;
    if (dir && corpo.animate) {
        corpo.animate([{ transform: `translateX(${dir * 40}px)`, opacity: 0.4 }, { transform: 'none', opacity: 1 }], { duration: 180, easing: 'ease-out' });
    }
    if (!ja) {
        abrirSheet(el, { marca: 'v2Vaga', endereco: _urlComVaga(id) });
    } else {
        history.replaceState(history.state, '', _urlComVaga(id));
    }
    registrarEvento('vaga_aberta', { origem: 'sheet', vaga_id: id });
    _opcoes.aoAbrir?.(id);
    setTimeout(() => $('vt-sheet')?.focus({ preventScroll: true }), ja ? 0 : 280);

    let html;
    try {
        html = await _corpo(id, base.href);
    } catch (e) {
        if (_sheet === id) {
            _hrefs.set(id, base.href);
            corpo.querySelector('.vd--sk')?.replaceWith(Object.assign(document.createElement('div'), {
                className: 'offline',
                innerHTML: _falhaDoCorpo(e)
            }));
        }
        return;
    }
    if (_sheet !== id) {
        return;
    }
    const artigo = _modelo(html);
    if (!artigo) {
        return;
    }
    _cidadeDoCard(artigo, id);
    const infoFinal = _infoDoArtigo(artigo, base);
    artigo.setAttribute('aria-labelledby', 'vt-sheet');
    artigo.querySelector('.vd__t').id = 'vt-sheet';
    _voltarTrilha(artigo);
    _extrasDoSheet(artigo, infoFinal);
    requestAnimationFrame(() => setTimeout(() => {
        if (_sheet !== id) {
            return;
        }
        corpo.replaceChildren(artigo);
        _carregarCta(id);
    }, 0));
}

async function _passo(delta) {
    _confirmando = null;
    let ids = _opcoes.lista();
    let i = ids.indexOf(_sheet);
    if (delta > 0 && i === ids.length - 1 && await _opcoes.carregarMais()) {
        ids = _opcoes.lista();
        i = ids.indexOf(_sheet);
    }
    const alvo = ids[i + delta];
    if (alvo) {
        marcarVista(_sheet);
        abrirNoSheet(alvo, { dir: delta });
    }
}

// ---------- candidatura ----------
const _livres = new Set(['Liberado', 'Cancelado', 'NaoLogado']);
const _gatilhoIcone = { alarm: ['clock', ''], 'hourglass-split': ['hourglass-split', ''], stars: ['stars', ''], 'people-fill': ['people', ''], 'arrow-clockwise': ['arrow-counterclockwise', 'ico--flip'] };

function gatilhoHtml(r) {
    if (!r?.gatilho?.titulo) {
        return '';
    }
    const nome = /bi-([\w-]+)/.exec(r.gatilho.icone || '')?.[1];
    const [i, cls] = _gatilhoIcone[nome] || ['stars', ''];
    return `<p class="gatilho">${ico(i, cls)}${esc(r.gatilho.titulo)}</p>`;
}

const _idAtual = () => _opcoes.pagina || (ehCelular() ? _sheet : _sel);
const _artigo = () => (_opcoes.pagina || !ehCelular() ? $('pane') : $('sheetBody'))?.querySelector('article.vd');

let _ctaControlador = null;
async function _carregarCta(id) {
    // O corpo da vaga acabou de entrar na tela (painel, sheet ou página): o link de denúncia já sai no estado certo.
    _pintarDenuncia();
    _ctaControlador?.abort();
    const controlador = new AbortController();
    _ctaControlador = controlador;
    let r;
    try {
        r = await obterJson(url(`/Vagas/BotaoCandidatar/${id}`), { semCache: true, sinal: controlador.signal });
    } catch (e) {
        if (e.name === 'AbortError') {
            return;
        }
        r = { retorno: 'Erro', retornoMensagem: T.erroBotao, falhou: true };
    }
    // Uma resposta que saiu antes do envio desta página (ou que falhou) não desfaz o "enviada": fica o quadro de enviada.
    if (_enviadas.has(id) && r.retorno !== 'Inscrito') {
        if (_idAtual() === id) {
            _desenharCta(id);
        }
        return;
    }
    _estadoCta.set(id, r);
    // No painel a vaga foi aberta a partir da busca, nesta página: é a origem que a página do v1 gravaria.
    if (!r.falhou && _paraVisualizar.delete(id)) {
        registrarVisualizacao(id, r, _opcoes.pagina ? {} : { origem: window.location.host });
    }
    if (tiraPendencia(r)) {
        removerPendencia(id);
    }
    if (_idAtual() !== id) {
        return;
    }
    if (r.retorno === 'Inscrito') {
        _marcarEnviada(id);
    }
    if (_confirmarAoAbrir === id && r.retorno !== 'NaoLogado' && _livres.has(r.retorno)) {
        _confirmarAoAbrir = null;
        // Voltou do login ou do cadastro depois de tocar em "Candidate-se": a candidatura sai sem perguntar de novo. A vaga em
        // várias cidades abre a escolha delas, a única confirmação que fica.
        // Sem a pendência desta vaga no aparelho, o ?confirmar=1 é só um link (qualquer um monta): abre a confirmação, como o v1.
        const daPendencia = _pendenciaDaVaga(id);
        if (daPendencia && !_artigo()?.dataset.cidades) {
            _desenharCta(id);
            _enviarDireto(id);
            return;
        }
        if (daPendencia) {
            _faltaCidade = id;
        }
        _confirmando = id;
        // Sem pendência, a trava de 600 ms vale desde já: o foco cai no "Confirmar envio" e um Enter preso não envia.
        _confirmouEm = daPendencia ? 0 : Date.now();
    }
    _desenharCta(id);
}

function _confirmacao(artigo) {
    const titulo = artigo.dataset.titulo;
    const texto = artigo.dataset.confidencial ? formatar(T.confirmarTextoConf, esc(titulo)) : formatar(T.confirmarTexto, esc(titulo), esc(artigo.dataset.empresa));
    let cidades = [];
    try {
        cidades = artigo.dataset.cidades ? JSON.parse(artigo.dataset.cidades) : [];
    } catch {
        cidades = [];
    }
    const escolha = cidades.length > 1
        ? `<fieldset class="confirm__cidades"><legend>${esc(T.cidadesPergunta)}</legend>${cidades.map(c => `<label class="opt"><input type="checkbox" name="CidadesInteresse" value="${esc(c.id)}"><span class="opt__l">${esc(c.nome)}</span></label>`).join('')}</fieldset>`
        : '';
    const soCidade = _faltaCidade === +artigo.dataset.id;
    return `<div class="confirm" role="alert"><b>${esc(soCidade ? T.faltaCidade : T.confirmarTitulo)}</b><span>${texto}</span>${escolha}<div class="confirm__row"><button class="btn btn--pri js-apply confirm__ok" type="button">${esc(soCidade ? T.enviarCandidatura : T.confirmarEnvio)}</button><button class="btn btn--ghost" type="button" data-cancel-apply="1">${esc(T.cancelar)}</button></div></div>`;
}

// "Candidate-se até": a data vem do BotaoCandidatar (sem cache, já no fuso de quem vê) e só aparece com a candidatura liberada.
function _desenharPrazo(artigo, prazo) {
    const caixa = artigo.querySelector('[data-prazo]');
    if (!caixa) {
        return;
    }
    caixa.removeAttribute('aria-busy');
    caixa.querySelector('.vd__prazo-sk')?.remove();
    caixa.hidden = !prazo?.data;
    if (caixa.hidden) {
        return;
    }
    const tempo = caixa.querySelector('[data-prazo-data]');
    tempo.textContent = prazo.data;
    tempo.dateTime = prazo.iso || '';
    caixa.querySelector('[data-prazo-fuso]').textContent = prazo.fuso || '';
    caixa.querySelector('p').hidden = false;
}

// "Prepare-se para esta vaga" (só no HTML do www em português): para quem entrou, nunca com a vaga encerrada nem com o
// questionário da candidatura pendente. Na página o bloco fica fora do artigo, por isso a busca é pelo ID da vaga.
function _desenharPreparo(id, r) {
    const prep = document.querySelector(`[data-vd-prep="${id}"]`);
    if (prep) {
        // Só para quem entrou e ainda pode se candidatar. Depois de enviada, o treino fica no quadro de enviada (que não vem antes
        // do questionário) e, em outra visita, no detalhe da candidatura, que confere o questionário no servidor.
        prep.hidden = !r.pessoaID || !['Liberado', 'Cancelado', 'CurriculoIncompleto'].includes(r.retorno);
    }
}

function _desenharCta(id) {
    const r = _estadoCta.get(id);
    const artigo = _artigo();
    if (!r || !artigo || +artigo.dataset.id !== id) {
        return;
    }
    _desenharPreparo(id, r);
    const cta = artigo.querySelector('.vd__cta');
    const livre = _livres.has(r.retorno);
    _desenharPrazo(artigo, livre ? r.prazo : null);
    // Como no v1, o WhatsApp é oferecido a quem não entrou; logado, a candidatura é pelo site.
    const wa = r.retorno === 'NaoLogado' && r.aceitarCandidaturaBot;
    const gat = livre ? gatilhoHtml(r) : '';
    const mensagem = (r.retornoMensagem || '').replace(/##nomeEmpresa##/g, artigo.dataset.empresa || '');

    artigo.querySelector('.confirm')?.remove();
    artigo.querySelector('.vd__offline-cta')?.remove();
    if (_pendente?.id === id) {
        cta.insertAdjacentHTML('beforebegin', `<div class="offline vd__offline-cta" role="alert"><span>${esc(T.semInternetCandidatura)}</span></div>`);
    }
    if (livre) {
        cta.innerHTML = `<div class="vd__cta-row"><button class="btn btn--pri js-apply" type="button">${ico('clipboard-check')}${esc(T.candidatese)}</button>${wa ? `<button class="btn btn--wa js-wa" type="button">${ico('whatsapp')}${esc(T.candidateseWa)}</button>` : ''}${gat}</div>${gat}`;
        if (_confirmando === id) {
            cta.insertAdjacentHTML('beforebegin', _confirmacao(artigo));
        }
    } else if (r.retorno === 'Inscrito') {
        cta.innerHTML = _enviadas.has(id) ? _quadroEnviada(id, artigo) : `<div class="trust">${ico('check-circle-fill')}<span><b>${esc(T.enviada)}</b> ${formatar(esc(T.enviadaAcompanhe), `<a href="${url('/candidato/candidaturas')}">${esc(T.minhasCandidaturas)}</a>`)}</span></div>`;
    } else if (r.retorno === 'CurriculoIncompleto') {
        // O currículo completo é um passo do login v2 (só o que falta, com a leitura do arquivo por IA), e não a tela de hoje.
        cta.innerHTML = `<p class="gatilho">${esc(mensagem)}</p><div class="vd__cta-acao"><a class="btn btn--pri vd__completar" href="${_enderecoDoCurriculo(id)}" data-curriculo-incompleto>${ico('file-earmark-text')}${esc(T.completarCandidatar)}</a></div>`;
    } else if (r.retorno === 'VagaEncerrada') {
        // O aviso e os motivos possíveis (a empresa encerrou, o prazo venceu ou a vaga foi cancelada).
        cta.innerHTML = `<div class="offline" role="status"><span>${esc(mensagem || T.erroBotao)}</span></div><div class="vd__motivos"><p>${esc(T.encerradaMotivos)}</p><ul>${(T.encerradaMotivoLista || []).map(m => `<li>${esc(m)}</li>`).join('')}</ul></div>`;
    } else if (r.retorno === 'AlunoSemMatricula' || r.retorno === 'AlunoNaoEncontrado') {
        // Vaga "Somente Para Alunos" (www e genéricos): a matrícula é conferida na empresa desta vaga, que vai junto, e a tela volta
        // para ela. Na "não encontrada" o mesmo botão corrige um número digitado errado, como a v1.
        cta.innerHTML = `<div class="offline" role="status"><span>${esc(mensagem)}</span><a class="btn btn--sm btn--out" href="${url(`/candidato/matricula?vaga=${id}&ReturnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`)}">${esc(T.vincularMatricula)}</a></div>`;
    } else if (r.retorno === 'DeficienciaObrigatoria') {
        cta.innerHTML = `<div class="offline" role="status"><span>${esc(mensagem)}</span><a class="btn btn--sm btn--out" href="${url('/candidato/curriculo#cv-pcd')}">${esc(T.informarDeficiencia)}</a></div>`;
    } else if (r.retorno === 'LimiteUltrapassado') {
        // As candidaturas que contam no limite são dado pessoal: vêm só do BotaoCandidatar (no-store), nunca do HTML da vaga.
        const contam = Array.isArray(r.limite) ? r.limite : [];
        const lista = contam.length ? `<p>${esc(T.limiteTitulo)}</p><ul>${contam.map(c => `<li><a href="${url(`/candidato/inscricao_${Number(c.id)}`)}">${esc(c.titulo)}</a></li>`).join('')}</ul>` : '';
        cta.innerHTML = `<div class="offline" role="status"><span>${esc(mensagem)}</span></div><div class="vd__motivos">${lista}<p class="vd__motivos-nota">${esc(T.limiteNota)}</p></div>`;
    } else {
        cta.innerHTML = `<div class="offline" role="status"><span>${esc(mensagem || T.erroBotao)}</span>${r.retorno === 'Erro' ? `<button class="btn btn--sm btn--out" type="button" data-cta-retry>${esc(T.tentarDeNovo)}</button>` : ''}</div>`;
    }
    cta.hidden = _confirmando === id && livre;
    cta.classList.toggle('vd__cta--ok', r.retorno === 'Inscrito' && _enviadas.has(id));
    cta.classList.remove('cta-wait');
    cta.removeAttribute('aria-busy');

    if (!ehCelular()) {
        const barra = $('pane')?.querySelector('.pane__bar');
        const ctab = barra?.querySelector('.pane__ctab');
        if (ctab) {
            ctab.classList.remove('cta-wait');
            ctab.removeAttribute('aria-busy');
            ctab.hidden = !livre;
        }
        if (_confirmando === id) {
            // Na página a linha de cima não é redesenhada a cada vaga: o botão só se esconde enquanto a confirmação está aberta.
            _opcoes.pagina ? ctab && (ctab.hidden = true) : ctab?.remove();
            setTimeout(() => artigo.querySelector('.confirm__ok')?.focus(), 0);
        }
        return;
    }

    // Na página, o rodapé fixo é o do painel que sobe de baixo, sem anterior e próxima.
    const pe = _opcoes.pagina ? $('vpStick') : $('sheetFoot');
    const apply = pe.querySelector('.js-apply');
    pe.classList.remove('cta-wait');
    pe.removeAttribute('aria-busy');
    pe.classList.toggle('is-confirm', _confirmando === id && livre);
    pe.classList.toggle('has-wa', wa && _confirmando !== id);
    $(_opcoes.pagina ? 'vpStickWa' : 'sheetWa').hidden = !wa || _confirmando === id;
    // Enviada: o botão desabilitado parecia clicável. No painel fica o aviso em texto entre Anterior e Próxima; na página o
    // rodapé some, porque a vaga já mostra o aviso com o link para Minhas candidaturas.
    apply.hidden = !livre;
    apply.innerHTML = _confirmando === id ? esc(T.confirmarEnvio) : ico('clipboard-check') + esc(T.candidatese);
    if (_opcoes.pagina) {
        pe.hidden = apply.hidden;
    } else {
        $('sheetOk').hidden = r.retorno !== 'Inscrito';
    }
    if (_confirmando === id) {
        _opcoes.pagina ? artigo.querySelector('.confirm')?.scrollIntoView({ block: 'center' }) : ($('sheetBody').scrollTop = 0);
    }
}

function _lerCookie(nome) {
    const m = document.cookie.match(new RegExp('(?:^|; )' + nome.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
    if (!m) {
        return '';
    }
    // O v1 grava o valor cru (salvarCookie.js): um "%" solto não pode derrubar a candidatura.
    try {
        return decodeURIComponent(m[1]);
    } catch {
        return m[1];
    }
}

// Mesmos campos do v1 (vagas-detalhes.js): origem do cadastro, de onde veio e o tipo de aparelho.
function _origem() {
    const q = new URLSearchParams(window.location.search);
    return document.referrer.split('/')[2] || q.get('source') || q.get('utm_source') || '';
}

function _dispositivo() {
    const ua = navigator.userAgent;
    if (/Tablet|iPad/i.test(ua)) {
        return 'Tablet';
    }
    return /Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i.test(ua) ? 'Mobile' : 'Desktop';
}

async function enviarCandidatura(id, cidadesEscolhidas) {
    const dados = new FormData();
    dados.append('id', id);
    cidadesEscolhidas.forEach(c => dados.append('CidadesInteresse', c));
    dados.append('VariasCidades', cidadesEscolhidas.varias ? 'True' : 'False');
    dados.append('source', _lerCookie('origemCadastro'));
    dados.append('referer', _origem());
    dados.append('dispositivo', _dispositivo());
    return enviarFormulario(url('/Vagas/ConfirmarCandidatura'), dados);
}

function _depoisDoEnvio(id, r) {
    if (_pendente?.id === id) {
        _pendente = null;
    }
    // "Inscrito" com id é a candidatura que já existia (outra aba, a resposta de antes perdida na rede): não conta de novo.
    if (r.id > 0 && r.retorno !== 'Inscrito') {
        _confirmando = null;
        _faltaCidade = null;
        removerPendencia(id);
        registrarConversaoCandidatura();
        registrarEvento('candidatura_concluida', { canal: 'empregare', vaga_id: id });
        // O questionário da empresa vem no quadro de enviada ("Falta 1 passo"), e não mais direto.
        const questionario = r.questionarioRespostaTriagem && r.questionarioRespostaTriagem !== 0
            ? url(`/candidato/questionario/${r.questionarioRespostaTriagem}_${r.id}?ocultaOrientacoes=true`)
            : r.questionario ? url(`/candidato/questionarios/${id}_${r.id}?inscricao=${id}`) : '';
        let contaNova = '';
        try {
            contaNova = sessionStorage.getItem('v2-conta-nova') || '';
            sessionStorage.removeItem('v2-conta-nova');
        } catch {
            // Sem armazenamento, o quadro só não diz que a conta foi criada.
        }
        _enviadas.set(id, { questionario, contaNova, conta: r.conta || null, alerta: false, contatoFeito: false });
        _estadoCta.set(id, { ...(_estadoCta.get(id) || {}), retorno: 'Inscrito' });
        _marcarEnviada(id);
        avisarSucesso(questionario ? T.okQuestTitulo : T.enviadaAviso);
        _desenharCta(id);
        _artigo()?.querySelector('.ok')?.scrollIntoView({ block: 'nearest' });
        return;
    }
    if (r.retorno === 'CidadeNaoSelecionada') {
        avisarErro(T.cidadeNaoSelecionada);
        return;
    }
    _confirmando = null;
    _faltaCidade = null;
    if (tiraPendencia(r)) {
        removerPendencia(id);
    }
    if (r.retorno === 'Inscrito') {
        _marcarEnviada(id);
    }
    _estadoCta.set(id, r);
    _desenharCta(id);
}

// O envio não voltou. Com o aparelho sem rede, fica guardado e sai sozinho quando a conexão voltar; com rede (erro do
// servidor, conexão instável), o erro aparece com "Tentar de novo", que relê o botão (Inscrito, se o envio passou). O 401
// já virou o aviso de sessão.
function _falhaNoEnvio(id, escolhidas, erro) {
    if (navigator.onLine === false) {
        _pendente = { id, escolhidas };
        _desenharCta(id);
        return;
    }
    if (_pendente?.id === id) {
        _pendente = null;
    }
    if (erro?.message === 'HTTP 401') {
        _desenharCta(id);
        return;
    }
    _confirmando = null;
    _faltaCidade = null;
    _estadoCta.set(id, { retorno: 'Erro', retornoMensagem: T.erroEnvio || T.erroBotao, falhou: true });
    _desenharCta(id);
}

// Voltou do login com a intenção clara: envia sem a confirmação (o envio é o mesmo, com as mesmas travas).
async function _enviarDireto(id) {
    if (_enviando || _saindo) {
        return;
    }
    _enviando = true;
    const semCidades = Object.assign([], { varias: false });
    try {
        _depoisDoEnvio(id, await enviarCandidatura(id, semCidades));
    } catch (e) {
        _falhaNoEnvio(id, semCidades, e);
    } finally {
        _enviando = false;
    }
}

// A volta do login: a mesma vaga (na busca, com os filtros e ?vaga=) já pedindo o envio.
function _enderecoDeVolta(id) {
    const volta = new URL(window.location.href);
    if (!_opcoes.pagina) {
        volta.searchParams.set('vaga', id);
    }
    volta.searchParams.set('confirmar', '1');
    return volta.pathname + volta.search;
}

const _enderecoDoCurriculo = id => url(`/login?curriculo=${id}&ReturnUrl=${encodeURIComponent(_enderecoDeVolta(id))}`);

// "Candidatura enviada": o que acontece agora e o que aumenta as chances. Contato velho e dados que faltam vêm aqui, depois
// do envio, e não numa tela antes da vaga (ConfirmarCandidatura devolve em "conta").
function _quadroEnviada(id, artigo) {
    const e = _enviadas.get(id);
    const empresa = artigo.dataset.confidencial ? T.okEmpresaConfidencial : artigo.dataset.empresa;
    const empresaHtml = `<b>${esc(empresa)}</b>`;
    const volta = encodeURIComponent(_opcoes.pagina ? window.location.pathname : `${window.location.pathname}?vaga=${id}`);
    const conta = e.conta || {};
    let html = `<div class="ok" role="status"><div class="ok__hd"><span class="ok__ic" aria-hidden="true">${ico('check-lg')}</span><div><p class="ok__t">${esc(e.questionario ? T.okQuestTitulo : T.okTitulo)}</p><p class="ok__s">${formatar(esc(e.questionario ? T.okQuestTexto : T.okTexto), empresaHtml)}</p></div></div>`;
    if (e.questionario) {
        html += `<a class="btn btn--pri btn--block ok__quest" href="${esc(e.questionario)}">${ico('clipboard-check')}${esc(T.okQuestBotao)}</a>`;
    }
    if (e.contaNova) {
        html += `<p class="ok__conta">${ico('person-circle')}<span>${formatar(esc(T.okContaNova), `<b>${esc(e.contaNova)}</b>`)}</span></p>`;
    }
    if (conta.termosDesatualizados) {
        html += `<div class="ok__caixa"><p><b>${esc(T.okTermosTexto)}</b></p><div class="ok__row"><a class="btn btn--sm btn--pri ok__btn" href="${url(`/candidato/termos?ReturnUrl=${volta}`)}">${esc(T.okTermosBotao)}</a></div></div>`;
    } else if (conta.contatoDesatualizado) {
        html += e.contatoFeito
            ? `<p class="ok__conta">${ico('check-circle-fill')}<span>${esc(T.okContatoObrigado)}</span></p>`
            : `<div class="ok__caixa"><p><b>${esc(T.okContatoPergunta)}</b><span>${esc([conta.email, conta.celular].filter(Boolean).join(' · '))}</span></p><div class="ok__row"><button class="btn btn--sm btn--pri ok__btn" type="button" data-ok-contato="${id}">${esc(T.okContatoSim)}</button><a class="btn btn--sm btn--ghost" href="${url(`/candidato/atualizacao-contato?ReturnUrl=${volta}`)}">${esc(T.okContatoAtualizar)}</a></div></div>`;
    } else if (conta.dadosFaltantes) {
        html += `<div class="ok__caixa"><p><b>${esc(T.okDadosTexto)}</b></p><div class="ok__row"><a class="btn btn--sm btn--ghost" href="${url(`/candidato/concluir-cadastro?ReturnUrl=${volta}`)}">${esc(T.okDadosBotao)}</a></div></div>`;
    }
    if (!e.questionario) {
        const cargo = artigo.dataset.cargo || artigo.dataset.titulo;
        const local = artigo.dataset.alertaLocal || '';
        const textoAlerta = local ? formatar(T.okAlertaTextoLocal, cargo, artigo.dataset.local) : formatar(T.okAlertaTexto, cargo);
        html += `<div class="ok__next"><p class="ok__h">${esc(T.okChances)}</p>`;
        if (_progressoCurriculo !== null && _progressoCurriculo < 100) {
            html += `<a class="ok__a" href="${url('/candidato/curriculo')}">${ico('file-earmark-text')}<span><b>${esc(T.okCurriculo)}</b><small>${esc(formatar(T.okCurriculoTexto, _progressoCurriculo))}</small></span>${ico('chevron-right')}</a>`;
        }
        html += `<button class="ok__a" type="button" data-ok-alerta="${id}" aria-haspopup="dialog">${ico(e.alerta ? 'bell-fill' : 'bell')}<span><b>${esc(e.alerta ? T.okAlertaLigado : T.okAlerta)}</b><small>${esc(textoAlerta)}</small></span>${ico(e.alerta ? 'check-lg' : 'chevron-right')}</button>`;
        // O treino opcional (só no www em português: o template vem do servidor), depois do que melhora as chances.
        html += `${document.querySelector(`template[data-vd-prep-ok="${id}"]`)?.innerHTML || ''}</div>`;
    }
    html += `<a class="ok__link" href="${url('/candidato/candidaturas')}">${esc(T.okAcompanhar)}</a></div>`;
    return html;
}

// O % do currículo do quadro de enviada (GetUsuarioLogado, uma chamada por página).
let _progressoCurriculo = null;
obterUsuario().then(u => {
    const pct = Number(u?.curriculoProgresso);
    _progressoCurriculo = u?.logado && Number.isFinite(pct) ? pct : null;
}).catch(() => {});

async function _confirmarContato(id, botao) {
    const dados = new FormData();
    dados.append('ReturnUrl', window.location.pathname);
    dados.append('versaoTermosDeUso', '0');
    const r = await comBotao(botao, () => enviarFormulario(url('/PainelNotificacoes/AtualizacaoDadosContinuarSemAlterar'), dados).catch(() => null));
    if (r === undefined) {
        return;
    }
    if (!r?.sucesso) {
        avisarErro(T.erroBotao);
        return;
    }
    _enviadas.get(id).contatoFeito = true;
    _desenharCta(id);
}

// O alerta das vagas parecidas: a janela do alerta já preenchida com o cargo e a cidade da vaga (ou o alerta que já tem o cargo).
async function _abrirAlerta(id, botao) {
    const artigo = _artigo();
    if (!artigo || ocupado(botao)) {
        return;
    }
    ocupar(botao);
    try {
        const abriu = await abrirAlertaDaBusca(artigo.dataset.cargo || artigo.dataset.titulo || '', artigo.dataset.alertaLocal || '', {
            gatilho: botao,
            // "Ligado" só se o alerta salvo ainda cobre a vaga e não está pausado (a pessoa pode ter tirado o cargo ou a cidade).
            aoMudar: async () => {
                let ligado = false;
                try {
                    const r = await obterAlertaDaBusca(artigo.dataset.cargo || artigo.dataset.titulo || '', artigo.dataset.alertaLocal || '');
                    ligado = !!r.cobre && !r.alerta?.pausado;
                } catch {
                    ligado = false;
                }
                const e = _enviadas.get(id);
                if (e) {
                    e.alerta = ligado;
                }
                _desenharCta(id);
                _artigo()?.querySelector(`[data-ok-alerta="${id}"]`)?.focus();
            }
        });
        // A sessão venceu: o login volta para cá (o botão fica com a roda até a página trocar).
        if (!abriu) {
            window.location.href = url(`/login?ReturnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`);
            return;
        }
        ocupar(botao, false);
    } catch {
        ocupar(botao, false);
        avisarErro(T.erroAlerta || T.erroBotao);
    }
}

async function _candidatar(botao) {
    const id = _idAtual();
    const r = _estadoCta.get(id);
    if (!id || !r || !_livres.has(r.retorno)) {
        return;
    }
    if (r.retorno === 'NaoLogado') {
        // Login em página inteira, com a pendência do v1 (o cadastro também guarda a vaga). O login volta pelo ReturnUrl:
        // a busca com a vaga aberta, já pedindo a confirmação.
        const artigo = _artigo();
        salvarPendencia(id, artigo?.dataset.titulo, artigo?.dataset.url, false);
        window.location.href = url(`/login?ReturnUrl=${encodeURIComponent(_enderecoDeVolta(id))}`);
        return;
    }
    const artigo = _artigo();
    if (_confirmando !== id) {
        // Quem entrou envia no 1º toque, sem a pergunta de confirmação. Só a vaga em várias cidades abre a escolha delas, e o
        // v1 guarda a pendência ao abrir (a pessoa pode sair sem escolher).
        if (artigo?.dataset.cidades) {
            _confirmando = id;
            _confirmouEm = Date.now();
            salvarPendencia(id, artigo.dataset.titulo, artigo.dataset.url, true);
            _desenharCta(id);
            return;
        }
    } else {
        // Na escolha das cidades (ou no ?confirmar=1 sem pendência): um 2º toque em menos de 600 ms é ignorado, e fora do quadro
        // o botão só leva o foco até ele.
        if (Date.now() - _confirmouEm < 600) {
            return;
        }
        if (!botao || !(botao.classList.contains('confirm__ok') || botao.closest('#sheetFoot, #vpStick'))) {
            artigo?.querySelector('.confirm__ok')?.focus();
            return;
        }
    }
    const escolhidas = [...(artigo?.querySelectorAll('.confirm input[name="CidadesInteresse"]:checked') || [])].map(i => i.value);
    escolhidas.varias = !!artigo?.dataset.cidades;
    if (escolhidas.varias && !escolhidas.length) {
        avisarErro(T.cidadeNaoSelecionada);
        return;
    }
    if (_enviando || _saindo) {
        return;
    }
    _enviando = true;
    // A roda no botão tocado até a resposta: o _desenharCta redesenha o botão; quando não redesenha (erro, falta a cidade), ela sai aqui.
    ocupar(botao);
    try {
        _depoisDoEnvio(id, await enviarCandidatura(id, escolhidas));
    } catch (e) {
        _falhaNoEnvio(id, escolhidas, e);
    } finally {
        _enviando = false;
        ocupar(botao, false);
    }
}

// Voltou do questionário pelo bfcache: a página é a mesma, a trava de saída não vale mais.
window.addEventListener('pageshow', e => {
    if (e.persisted) {
        _saindo = false;
    }
});

window.addEventListener('online', async () => {
    // A mesma trava do toque: um envio de cada vez (a conversão não pode contar duas vezes).
    if (!_pendente || _enviando || _saindo) {
        return;
    }
    const { id, escolhidas } = _pendente;
    _enviando = true;
    try {
        const r = await enviarCandidatura(id, escolhidas);
        _depoisDoEnvio(id, r);
        if (r.id > 0 && r.retorno !== 'Inscrito') {
            avisarSucesso(T.candidaturaReenviada);
        }
    } catch (e) {
        // Sem rede de novo, continua guardada para a próxima volta da conexão.
        _falhaNoEnvio(id, escolhidas, e);
    } finally {
        _enviando = false;
    }
});

// ---------- compartilhar ----------
let _compartilharDe = null;
function _compartilhar(ancora) {
    const artigo = _artigo();
    if (!artigo) {
        return;
    }
    const local = artigo.dataset.local || '';
    compartilharPagina({
        link: new URL(artigo.dataset.url, window.location.origin).href,
        titulo: artigo.dataset.titulo,
        texto: artigo.dataset.confidencial ? formatar(T.compartilharTextoConf, artigo.dataset.titulo, local) : formatar(T.compartilharTexto, artigo.dataset.titulo, artigo.dataset.empresa, local),
        linha: `${artigo.dataset.empresa}${local ? ' · ' + local : ''}`,
        logo: artigo.querySelector('.vd__hd .card__logo')?.outerHTML || '',
        rotuloLink: T.linkVaga
    }, ancora);
}

// O compartilhar da vaga também serve à página da empresa: os mesmos canais com utm, a prévia e o copiar link.
// logo é HTML pronto (o card__logo da página); cabecalho troca o título do painel ("Compartilhar vaga" é o padrão).
export function compartilharPagina({ link, titulo, texto, linha, logo, rotuloLink, cabecalho }, ancora) {
    const comUtm = canal => `${link}?utm_source=${canal}&utm_medium=compartilhar`;
    const tituloPainel = $('shpT');
    if (tituloPainel) {
        tituloPainel.dataset.padrao ??= tituloPainel.textContent;
        tituloPainel.textContent = cabecalho || tituloPainel.dataset.padrao;
    }
    // No celular, o compartilhar do próprio aparelho; o painel é a reserva.
    if (ehCelular() && navigator.share) {
        navigator.share({ title: titulo, text: texto, url: comUtm('nativo') }).catch(() => {});
        return;
    }
    const e = encodeURIComponent;
    const canais = [
        ['whatsapp', 'WhatsApp', `https://wa.me/?text=${e(texto + ': ' + comUtm('whatsapp'))}`],
        ['linkedin', 'LinkedIn', `https://www.linkedin.com/sharing/share-offsite/?url=${e(comUtm('linkedin'))}`],
        ['facebook', 'Facebook', `https://www.facebook.com/sharer/sharer.php?u=${e(comUtm('facebook'))}`],
        ['telegram', 'Telegram', `https://t.me/share/url?url=${e(comUtm('telegram'))}&text=${e(texto)}`],
        ['envelope', T.email, `mailto:?subject=${e(texto)}&body=${e(texto + '\n\n' + comUtm('email'))}`]
    ];
    // O endereço da prévia é o do site em que a pessoa está (o hotsite mostra o subdomínio dele).
    $('shpBody').innerHTML = `<div class="shp__prev">${logo}<div><b>${esc(titulo)}</b><span>${esc(linha)}</span><small>${esc(window.location.host.replace(/^www\./, ''))}</small></div></div>
    <ul class="shp__ch">${canais.map(([k, l, href]) => `<li><a class="shp__c shp__c--${k}" href="${esc(href)}" target="_blank" rel="noopener" data-share-ch="${k}"><span class="shp__i">${ico(k)}</span>${esc(l)}</a></li>`).join('')}</ul>
    <div class="shp__link"><label class="sr" for="shpUrl">${esc(rotuloLink)}</label><input id="shpUrl" readonly value="${esc(link)}"><button class="btn btn--sm btn--navy" type="button" id="copyLink" data-url="${esc(link)}">${ico('copy')}<span>${esc(T.copiarLink)}</span></button></div>`;
    const p = $('sharePop');
    // No celular o painel sobe por cima da vaga: com a entrada própria no histórico, o Voltar fecha ele, e não a vaga de baixo.
    if (p.hidden && ehCelular()) {
        empilhar('v2Compartilhar', () => fecharCompartilhar({ peloHistorico: true }));
    }
    _compartilharDe = ancora;
    p.hidden = false;
    $('shpScrim').hidden = false;
    if (!ehCelular() && ancora) {
        const r = ancora.getBoundingClientRect();
        p.style.left = Math.max(12, Math.min(r.right - p.offsetWidth, window.innerWidth - p.offsetWidth - 12)) + 'px';
        p.style.top = (r.bottom + 6) + 'px';
    } else {
        p.style.left = '';
        p.style.top = '';
    }
    ancora?.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => p.querySelector('.shp__c')?.focus());
}

export function fecharCompartilhar({ peloHistorico = false } = {}) {
    const p = $('sharePop');
    if (!p || p.hidden) {
        return false;
    }
    p.hidden = true;
    $('shpScrim').hidden = true;
    if (!peloHistorico) {
        desempilhar('v2Compartilhar');
    }
    _compartilharDe?.setAttribute('aria-expanded', 'false');
    _compartilharDe?.focus();
    _compartilharDe = null;
    return true;
}

// ---------- denúncia (o formulário da página da vaga, num <dialog>) ----------
let _denunciaEnviando = false;
// Telefone com a bandeira do país e a máscara do Brasil: as regras do v1 (utilidades/configurarTelefoneInputPlugins.js).
// As bibliotecas (intl-tel-input e IMask) só baixam quando a janela abre.
let _telefone = null;
let _mascara = null;
async function _telefoneDaDenuncia(janela) {
    if (!_telefone) {
        const [{ default: intlTelInput }, { default: IMask }] = await Promise.all([
            import(/* webpackChunkName: "intl-tel-input" */ 'intl-tel-input'),
            import(/* webpackChunkName: "imask" */ 'imask')
        ]);
        const campo = $('denunciaTelefone');
        // No celular a lista de países abre em tela cheia e, sem container, iria para o <body>, embaixo da janela modal.
        const celular = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        _telefone = intlTelInput(campo, {
            initialCountry: 'br',
            preferredCountries: ['br', 'cl', 'ar', 'es', 'pt', 'us', 'fr'],
            dropdownContainer: celular ? janela : null,
            formatOnDisplay: false,
            autoPlaceholder: 'aggressive',
            utilsScript: '/assetsV2/lib/intl-tel-util/utils.js'
        });
        // Brasil: (00) 0000-0000 ou (00) 00000-0000 e número completo (14 caracteres); outro país, sem máscara.
        const mascararPorPais = () => {
            _mascara?.destroy();
            _mascara = null;
            if (_telefone.getSelectedCountryData().dialCode === '55') {
                _mascara = IMask(campo, { mask: [{ mask: '(00) 0000-0000' }, { mask: '(00) 00000-0000' }] });
                campo.dataset.minimo = '14';
            } else {
                delete campo.dataset.minimo;
            }
        };
        mascararPorPais();
        campo.addEventListener('countrychange', () => {
            mascararPorPais();
            if ($('formDenuncia').dataset.validado) {
                _mostrarErroDoCampo(campo);
            }
        });
    }
    return _telefone;
}

// Com a máscara ligada, o número entra por ela (senão o IMask fica com o valor antigo).
function _preencherTelefone(numero) {
    const campo = $('denunciaTelefone');
    if (_mascara) {
        _mascara.value = numero;
    } else {
        campo.value = numero;
    }
}

// A vaga denunciada: a aberta no painel/sheet ou a da página da vaga (que passa o id e o endereço).
async function abrirDenuncia({ id, endereco } = {}) {
    const janela = $('dlgDenuncia');
    if (!janela || !id) {
        return false;
    }
    const form = $('formDenuncia');
    form.elements.VagaID.value = id;
    form.elements.VagaUrl.value = new URL(endereco, window.location.origin).href;
    janela.showModal();
    // Com entrada própria: aberta sobre o sheet da vaga, o Voltar fecha a denúncia e não o sheet por baixo.
    empilhar('v2Denuncia', () => janela.close());
    const telefone = await _telefoneDaDenuncia(janela);
    // Logado: e-mail e telefone (com o país) do cadastro, como no v1 (PaginasEstaticas/GetDetalhesPessoa, sem cache).
    if ((await obterUsuario()).logado && !form.elements.Email.value) {
        try {
            const r = await obterJson(url('/PaginasEstaticas/GetDetalhesPessoa'), { semCache: true });
            if (r?.logado && r.pessoa) {
                form.elements.Email.value = r.pessoa.Email || '';
                telefone.setNumber(r.pessoa.CelularPaisCode ?? r.pessoa.TelefonePaisCode ?? '');
                _preencherTelefone(r.pessoa.Celular ?? r.pessoa.Telefone ?? '');
            }
        } catch {
            // Sem o cadastro, o país vem da conexão (o mesmo do v1 quando a chamada falha).
            telefone.setCountry((obterGeo()?.pais || 'BR').toLowerCase());
        }
    }
    return true;
}

// Regras do v1 (JustValidate em vagas-detalhes.js): motivo, e-mail válido e detalhes com 20 caracteres ou mais;
// o telefone é opcional, mas no Brasil, se preenchido, tem de estar completo (configurarTelefoneInputPlugins.js).
function _erroDoCampo(campo) {
    const valor = campo.value.trim();
    if (!valor) {
        return campo.required ? campo.dataset.erroObrigatorio || '' : '';
    }
    if (campo.type === 'email' && campo.validity.typeMismatch) {
        return campo.dataset.erroFormato || '';
    }
    const minimo = +(campo.dataset.minimo || 0) || campo.minLength;
    if (minimo > 0 && valor.length < minimo) {
        return campo.dataset.erroMinimo || '';
    }
    return '';
}

function _mostrarErroDoCampo(campo) {
    const erro = _erroDoCampo(campo);
    const aviso = document.getElementById(campo.getAttribute('aria-describedby'));
    campo.closest('.campo')?.classList.toggle('is-erro', !!erro);
    erro ? campo.setAttribute('aria-invalid', 'true') : campo.removeAttribute('aria-invalid');
    if (aviso) {
        aviso.textContent = erro;
        aviso.hidden = !erro;
    }
    return !erro;
}

// Depois da 1ª tentativa de envio, o erro de cada campo some (ou troca) enquanto a pessoa corrige.
function _validarDenuncia(form) {
    form.dataset.validado = '1';
    const campos = [...form.querySelectorAll('[data-validar]')];
    const invalidos = campos.filter(c => !_mostrarErroDoCampo(c));
    invalidos[0]?.focus();
    return !invalidos.length;
}

function _limparErrosDaDenuncia(form) {
    delete form.dataset.validado;
    form.querySelectorAll('[data-validar]').forEach(c => {
        c.closest('.campo')?.classList.remove('is-erro');
        c.removeAttribute('aria-invalid');
        const aviso = document.getElementById(c.getAttribute('aria-describedby'));
        if (aviso) {
            aviso.hidden = true;
        }
    });
}

async function _enviarDenuncia(form) {
    if (_denunciaEnviando || !_validarDenuncia(form)) {
        return;
    }
    _denunciaEnviando = true;
    try {
        const vagaID = form.elements.VagaID.value;
        const r = await comBotao(form.querySelector('[type="submit"]'), () => enviarFormulario(form.action, new FormData(form)));
        if (r?.sucesso) {
            form.reset();
            _mascara?.updateValue();
            _limparErrosDaDenuncia(form);
            $('dlgDenuncia').close();
            avisarSucesso(r.mensagem);
            _lembrarDenuncia(vagaID);
        } else if (r?.jaDenunciada) {
            // O servidor já tinha a denúncia desta pessoa para a vaga (outro aparelho, outro dia): nada foi gravado de novo.
            $('dlgDenuncia').close();
            avisar(r.mensagem);
            _lembrarDenuncia(vagaID);
        } else {
            avisarErro(r?.mensagem || T.denunciaErro);
        }
    } catch {
        avisarErro(T.denunciaErro);
    } finally {
        _denunciaEnviando = false;
    }
}

// A denúncia é uma só por pessoa e vaga. O aparelho lembra, nesta sessão, as vagas que já foram denunciadas (o HTML da vaga é
// público e igual para todos, então o estado não vem dele); quem barra a repetição de verdade é o servidor.
const _DENUNCIADAS = 'v2-vagas-denunciadas';

function _denunciadas() {
    try {
        return JSON.parse(sessionStorage.getItem(_DENUNCIADAS)) || [];
    } catch {
        return [];
    }
}

const _jaDenunciada = id => _denunciadas().includes(Number(id));

function _lembrarDenuncia(id) {
    try {
        sessionStorage.setItem(_DENUNCIADAS, JSON.stringify([..._denunciadas().filter(x => x !== Number(id)), Number(id)].slice(-200)));
    } catch {
        // Sem armazenamento, o servidor segue barrando a repetição.
    }
    _pintarDenuncia();
}

// "Denunciar esta vaga" vira "Vaga denunciada" (sem ação) onde a vaga já foi denunciada: no painel, no sheet e na página da vaga.
function _pintarDenuncia() {
    document.querySelectorAll('[data-denunciar]').forEach(link => {
        const id = link.closest('article.vd')?.dataset.id;
        if (!id || !_jaDenunciada(id) || !T.denunciada) {
            return;
        }
        link.classList.add('is-denunciada');
        link.setAttribute('aria-disabled', 'true');
        link.lastChild.textContent = T.denunciada;
    });
}

// ---------- salvar ----------
function _pintarSalva(id, salvou) {
    document.querySelectorAll(`.js-save[data-id="${id}"]`).forEach(b => {
        b.setAttribute('aria-pressed', String(salvou));
        b.innerHTML = `${ico(salvou ? 'bookmark-fill' : 'bookmark')}<span class="icon-btn__l">${esc(salvou ? T.salva : T.salvar)}</span>`;
    });
}

const _salvando = new Set();

async function _salvar(id) {
    // Na conta o envio leva um instante: o 2º toque não desfaz o 1º.
    if (_salvando.has(id)) {
        return;
    }
    _salvando.add(id);
    // A roda em todos os "Salvar" desta vaga (o do cartão e o do painel) até a conta responder.
    const botoes = [...document.querySelectorAll(`.js-save[data-id="${id}"]`)];
    botoes.forEach(b => ocupar(b));
    const salvou = await alternarSalva(id);
    botoes.forEach(b => ocupar(b, false));
    _salvando.delete(id);
    if (salvou === null) {
        avisarErro(T.erroSalvarVaga || T.erroBotao);
        return;
    }
    avisarSucesso(salvou ? (salvasNaConta() && T.salvaConta ? T.salvaConta : T.salvaAparelho) : T.removidaSalvas);
    if (salvou) {
        registrarEvento('vaga_salva', { vaga_id: id });
    }
    _pintarSalva(id, salvou);
    _opcoes.aoSalvar?.(id, salvou);
}

// ---------- eventos ----------
const _cliqueComum = e => e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey;

function _fecharAjuda(caixa) {
    caixa.classList.remove('is-open');
    caixa.querySelector('[data-ajuda]')?.setAttribute('aria-expanded', 'false');
}

export function iniciarVaga(opcoes) {
    _opcoes = { ..._opcoes, ...opcoes };
    $('formDenuncia')?.addEventListener('submit', e => {
        e.preventDefault();
        _enviarDenuncia(e.currentTarget);
    });
    ['input', 'change'].forEach(tipo => $('formDenuncia')?.addEventListener(tipo, e => {
        if (e.currentTarget.dataset.validado && e.target.matches('[data-validar]')) {
            _mostrarErroDoCampo(e.target);
        }
    }));
    // Fechou sem enviar: o que foi digitado fica, os erros saem (voltam só numa nova tentativa).
    $('dlgDenuncia')?.addEventListener('close', () => {
        _limparErrosDaDenuncia($('formDenuncia'));
        desempilhar('v2Denuncia');
    });
    T = opcoes.textos || {};
    const q = new URLSearchParams(window.location.search);
    if (q.get('confirmar') === '1' && (+q.get('vaga') > 0 || _opcoes.pagina)) {
        _confirmarAoAbrir = _opcoes.pagina || +q.get('vaga');
    }

    document.querySelectorAll('.sheet').forEach(s => {
        if (s.id !== 'sheetMenu') {
            arrastavel(s);
        }
    });

    // Deslizar para o lado no corpo do sheet troca de vaga; as bordas de 24 px ficam para o gesto do sistema.
    const corpo = $('sheetBody');
    let x0 = null;
    let y0 = 0;
    corpo?.addEventListener('pointerdown', e => {
        // A janela da seleção oculta mora no corpo: o arrasto dentro dela trocaria a vaga e tiraria a janela aberta da página.
        if (e.pointerType === 'mouse' || e.target.closest('dialog')) {
            return;
        }
        const r = corpo.getBoundingClientRect();
        if (e.clientX - r.left < 24 || r.right - e.clientX < 24) {
            return;
        }
        x0 = e.clientX;
        y0 = e.clientY;
    });
    corpo?.addEventListener('pointerup', e => {
        if (x0 === null) {
            return;
        }
        const dx = e.clientX - x0;
        const dy = e.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 90 && Math.abs(dx) > Math.abs(dy) * 2) {
            _passo(dx < 0 ? 1 : -1);
        }
    });
    corpo?.addEventListener('pointercancel', () => { x0 = null; });

    // A linha do topo do painel gruda e troca o logo pelo título quando o "Candidate-se" some atrás dela.
    // Na página da vaga quem rola é a janela.
    const aoRolarOPainel = () => {
        const p = $('pane');
        const cta = p?.querySelector('.vd__cta');
        const barra = p?.querySelector('.pane__bar');
        if (cta && barra) {
            p.classList.toggle('is-scrolled', cta.getBoundingClientRect().bottom <= barra.getBoundingClientRect().bottom + 4);
        }
    };
    (_opcoes.pagina ? window : $('paneWrap'))?.addEventListener('scroll', aoRolarOPainel, { passive: true });
    if (!_opcoes.pagina) {
        // Aberta no celular, a busca não desenha o painel do computador: ao alargar a janela ele ficava em branco.
        // Mostra a vaga do sheet (aberta ou a última que passou por ele), senão a 1ª da lista.
        window.matchMedia('(min-width: 960px)').addEventListener('change', e => {
            const id = _sheet || _ultimaDoSheet || _opcoes.lista()[0];
            if (e.matches && !_sel && id) {
                selecionarNoPainel(id, { doUsuario: false, visualizar: false });
            }
        });
    }
    if (_opcoes.pagina) {
        // Na página o corpo já veio no HTML: falta o estado pessoal (salva, botão de candidatura, visualização).
        _pintarSalva(_opcoes.pagina, estaSalva(_opcoes.pagina));
        _paraVisualizar.add(_opcoes.pagina);
        // Pré-renderizada pelo app: o botão é lido ao abrir (a pessoa pode ter se candidatado na tela anterior) e a volta do login
        // (?confirmar=1) só envia a candidatura com a página à vista.
        aoExibirPagina(() => _carregarCta(_opcoes.pagina));
    }

    // A lista da conta chegou depois de os botões aparecerem: eles passam a mostrar a conta.
    document.addEventListener('v2:salvas', () => {
        document.querySelectorAll('.js-save[data-id]').forEach(b => _pintarSalva(+b.dataset.id, estaSalva(b.dataset.id)));
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            document.querySelectorAll('.ajuda.is-open').forEach(_fecharAjuda);
        }
    });
    document.addEventListener('click', e => {
        const t = e.target;
        // Ajuda do prazo: o toque abre e fecha; qualquer outro clique fecha a que estiver aberta.
        const ajuda = t.closest('[data-ajuda]');
        document.querySelectorAll('.ajuda.is-open').forEach(caixa => {
            if (caixa !== ajuda?.parentElement) {
                _fecharAjuda(caixa);
            }
        });
        if (ajuda) {
            const aberta = ajuda.parentElement.classList.toggle('is-open');
            ajuda.setAttribute('aria-expanded', String(aberta));
            return;
        }
        // Na página da vaga, a vaga parecida abre a página dela (o link normal).
        const sim = !_opcoes.pagina && t.closest('#pane a[data-sim], #sheetBody a[data-sim]');
        if (sim && _cliqueComum(e) && new URL(sim.getAttribute('href') || '', window.location.href).origin === window.location.origin) {
            e.preventDefault();
            const atual = _idAtual();
            const artigo = _artigo();
            _trilha.push({ id: atual, titulo: artigo?.dataset.titulo || '' });
            const id = +sim.dataset.sim;
            _hrefs.set(id, sim.getAttribute('href'));
            const info = { id, titulo: sim.querySelector('b')?.textContent || '', empresa: (sim.querySelector('span')?.textContent || '').split(' · ')[0], logo: '', href: sim.getAttribute('href'), pills: '' };
            ehCelular() ? abrirNoSheet(id, { info }) : selecionarNoPainel(id, { info });
            return;
        }
        if (t.closest('[data-trail-back]')) {
            const anterior = _trilha.pop();
            if (anterior) {
                const info = _infoDoCartao(anterior.id) || { id: anterior.id, titulo: anterior.titulo, empresa: '', logo: '', href: _hrefs.get(anterior.id), pills: '' };
                ehCelular() ? abrirNoSheet(anterior.id, { info }) : selecionarNoPainel(anterior.id, { info });
            }
            return;
        }
        const cidades = t.closest('[data-cities]');
        if (cidades) {
            const lista = cidades.closest('.vd__where')?.nextElementSibling;
            const abrir = cidades.getAttribute('aria-expanded') !== 'true';
            if (lista?.classList.contains('vd__cities')) {
                lista.hidden = !abrir;
            }
            cidades.setAttribute('aria-expanded', String(abrir));
            cidades.textContent = abrir ? T.ocultarCidades : cidades.dataset.ver;
            return;
        }
        // Vídeo da empresa: o player só entra depois do clique, como na página da empresa.
        const video = t.closest('[data-vd-video]');
        if (video) {
            const src = video.dataset.vdVideo;
            const quadro = document.createElement('iframe');
            quadro.className = 'emp__video';
            quadro.src = `${src}${src.includes('?') ? '&' : '?'}autoplay=1`;
            quadro.title = video.querySelector('.emp__vlabel')?.textContent || '';
            quadro.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
            quadro.allowFullscreen = true;
            video.replaceWith(quadro);
            quadro.focus();
            return;
        }
        if (t.closest('[data-corpo-retry]')) {
            const id = _idAtual();
            if (id) {
                ehCelular() && !_opcoes.pagina ? abrirNoSheet(id) : selecionarNoPainel(id, { doUsuario: false, visualizar: false });
            }
            return;
        }
        const retry = t.closest('[data-cta-retry]');
        if (retry) {
            const id = _idAtual();
            // A roda até o botão da vaga voltar (o _carregarCta redesenha o quadro, com ou sem este botão).
            if (id && !ocupado(retry)) {
                ocupar(retry);
                _carregarCta(id);
            }
            return;
        }
        const incompleto = t.closest('[data-curriculo-incompleto]');
        if (incompleto) {
            // Como no v1: guarda a pendência (também no servidor) antes de sair; depois de completar, o fluxo de hoje volta à vaga.
            // Um toque só, com a roda: o lembrete do servidor espera no máximo 3 s.
            e.preventDefault();
            if (ocupado(incompleto)) {
                return;
            }
            ocupar(incompleto);
            const artigo = _artigo();
            Promise.race([salvarPendencia(artigo?.dataset.id || '', artigo?.dataset.titulo, artigo?.dataset.url, true), new Promise(fim => setTimeout(fim, 3000))])
                .finally(() => { window.location.href = incompleto.href; });
            return;
        }
        const contato = t.closest('[data-ok-contato]');
        if (contato) {
            _confirmarContato(+contato.dataset.okContato, contato);
            return;
        }
        const alerta = t.closest('[data-ok-alerta]');
        if (alerta) {
            _abrirAlerta(+alerta.dataset.okAlerta, alerta);
            return;
        }
        if (t.closest('[data-cancel-apply]') || t.closest('#sheetCancel, #vpStickCancel')) {
            // Com o envio a caminho, cancelar não o desfaz: o toque não muda nada.
            if (_enviando) {
                return;
            }
            const id = _confirmando;
            _confirmando = null;
            if (id) {
                ehCelular() || _opcoes.pagina ? _desenharCta(id) : selecionarNoPainel(id, { doUsuario: false });
            }
            return;
        }
        const aplicar = t.closest('#pane .js-apply, #sheetBody .js-apply, #sheetFoot .js-apply, #vpStick .js-apply');
        if (aplicar) {
            if (aplicar.closest('.cta-wait')) {
                return;
            }
            const id = _idAtual();
            if (_confirmando !== id) {
                registrarEvento('candidatura_iniciada', { canal: 'empregare', vaga_id: id, logado: _estadoCta.get(id)?.retorno !== 'NaoLogado' });
            }
            _candidatar(aplicar);
            return;
        }
        if (t.closest('#pane .js-wa, #sheetBody .js-wa, #sheetWa, #vpStickWa')) {
            const id = _idAtual();
            registrarEvento('candidatura_iniciada', { canal: 'whatsapp', vaga_id: id });
            const artigo = _artigo();
            candidatarPeloWhatsApp(id, { titulo: artigo?.dataset.titulo, endereco: artigo?.dataset.url });
            return;
        }
        if (t.closest('[data-qr-fechar]')) {
            $('dlgWhatsApp')?.close();
            return;
        }
        // Seleção oculta: o "Saiba mais" da tag abre a janela da vaga, com entrada própria (o Voltar fecha a janela, não o sheet).
        const cega = t.closest('[data-cega]');
        if (cega) {
            // A da mesma cópia do corpo: com a tela estreitando, a vaga pode estar no painel (escondido e inerte) e no sheet.
            const janela = cega.closest('#sheetBody, #pane')?.querySelector('.dlg-cega') || $(`dlgCega-${cega.dataset.cega}`);
            if (janela && !janela.open) {
                janela.showModal();
                empilhar('v2Cega', () => janela.close());
                janela.addEventListener('close', () => desempilhar('v2Cega'), { once: true });
            }
            return;
        }
        if (t.closest('[data-cega-fechar]')) {
            t.closest('dialog')?.close();
            return;
        }
        const salvar = t.closest('.js-save');
        if (salvar) {
            const id = +(salvar.dataset.id || _idAtual());
            if (id) {
                _salvar(id);
            }
            return;
        }
        const compartilhar = t.closest('#pane .js-share, #shareTg');
        if (compartilhar) {
            _compartilhar(compartilhar);
            return;
        }
        const denunciar = t.closest('#pane [data-denunciar], #sheetBody [data-denunciar]');
        if (denunciar && _cliqueComum(e)) {
            // Sem o <dialog> (página sem o formulário), o link leva à página da vaga.
            if ($('dlgDenuncia')) {
                e.preventDefault();
                // Já denunciada nesta sessão: o link é só a informação, não abre o formulário de novo.
                if (_jaDenunciada(_artigo()?.dataset.id)) {
                    avisar(T.denunciaJa || T.denunciada);
                    return;
                }
                abrirDenuncia({ id: _artigo()?.dataset.id, endereco: _artigo()?.dataset.url });
            }
            return;
        }
        if (t.closest('[data-denuncia-fechar]')) {
            $('dlgDenuncia')?.close();
            return;
        }
        if (t.closest('[data-share-close]') || t.closest('#shpScrim')) {
            fecharCompartilhar();
            return;
        }
        if (t.closest('[data-share-ch]')) {
            // O canal abre em outra aba ou, no navegador dos apps, nesta: aí o Voltar do fechar cancelaria a ida. Saindo da
            // página, o painel fica (a volta cai nele e o Voltar o fecha, como a vaga no "Abrir página").
            let saindo = false;
            const sair = () => { saindo = true; };
            window.addEventListener('beforeunload', sair, { once: true });
            setTimeout(() => {
                window.removeEventListener('beforeunload', sair);
                if (!saindo) {
                    fecharCompartilhar();
                }
            }, 0);
            return;
        }
        const copiar = t.closest('#copyLink');
        if (copiar) {
            const ok = () => {
                copiar.innerHTML = `${ico('check2')}<span>${esc(T.linkCopiado)}</span>`;
                copiar.classList.add('is-ok');
                setTimeout(() => {
                    copiar.innerHTML = `${ico('copy')}<span>${esc(T.copiarLink)}</span>`;
                    copiar.classList.remove('is-ok');
                }, 2200);
            };
            const manual = () => {
                $('shpUrl')?.focus();
                $('shpUrl')?.select();
                avisar(T.copiarManual);
            };
            try {
                navigator.clipboard.writeText(copiar.dataset.url).then(ok, manual);
            } catch {
                manual();
            }
            return;
        }
        if (t.closest('#sheetClose') || t.closest('#sheetVaga .sheet__grab')) {
            fecharSheet($('sheetVaga'));
            return;
        }
        if (t.closest('#sheetPrev')) {
            _passo(-1);
            return;
        }
        if (t.closest('#sheetNext') || t.closest('[data-next]')) {
            _passo(1);
            return;
        }
        if (t.closest('#scrim')) {
            document.querySelectorAll('.sheet.is-open:not(#sheetMenu)').forEach(s => fecharSheet(s));
        }
    });
}

export const vagaSelecionada = () => _sel;
